package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.CreatePaymentIntentRequest
import com.ijoin.data.model.CreatePaymentIntentResponse
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class PaymentApi {
    private val client = ApiClient.client

    suspend fun createPaymentIntent(
        request: CreatePaymentIntentRequest,
    ): Result<CreatePaymentIntentResponse> {
        return safeApiCall {
            client.post("${ApiClient.getBaseUrl()}/api/payments/intent") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        }.mapCatching { response ->
            response.body()
        }
    }
}
